import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { ActivatedRoute, Router } from "@angular/router";

import { TipoMultaService } from '../services/tipo-multa.service';
import Swal from 'sweetalert2';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';
import { AuthService } from '../services/auth.service';

@Component({
	selector: 'app-tipos-multa',
	templateUrl: './tipos-multa.component.html',
	styleUrls: ['./tipos-multa.component.css'],
	animations: [loadingFade, modal, alert]
})
export class TiposMultaComponent implements OnInit {
	public loading = false;
	public tiposmulta = [];

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	//acesso
	public menu_id = 126;
	public usuario_perfil;
	public visualizar = true;
	public editar = false;	

	constructor(private tipoMultaSvc: TipoMultaService,
		private route: ActivatedRoute,
		private perfilUsuarioSvc: PerfilUsuarioService,
		private authSvc: AuthService
		) { }

	ngOnInit() {

		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		}); 

		this.pegaTiposMulta();
	}

	pegaTiposMulta() {
		this.tiposmulta = [];
		this.loading = true;
		this.tipoMultaSvc.getTiposMulta('tipo_multa_id').then((data: any[]) => {
			this.tiposmulta = data;
			this.count = this.tiposmulta.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		});
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	apagaTipo(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.tipoMultaSvc.apagaTipoMulta(id).then((data) => {
					this.pegaTiposMulta();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}
}
